import React from 'react';
import { observer } from 'mobx-react';
import { FacilityInventoryCountDetailFullEditTemplate } from 'themes/application/facility-inventory/pages';
import { setCurrentView } from 'core/utils';
import { FacilityInventoryCountDetailEditViewStore } from 'application/facility-inventory/stores';

@setCurrentView((rootStore, componentProps) => new FacilityInventoryCountDetailEditViewStore(rootStore, componentProps), "facilityInventoryCountDetailEditViewStore")
@observer
class FacilityInventoryCountDetailFullEdit extends React.Component {
    render() {
        return <FacilityInventoryCountDetailFullEditTemplate {...this.props} />
    }
}

export default FacilityInventoryCountDetailFullEdit;